import { EIV_ENTRY_TYPE, EIV_ENTRY_TYPE_TO_GERMAN_NAME } from 'global/constants';

const EIV_ENTRY_TYPE_RADIO_OPTIONS = [
  { label: EIV_ENTRY_TYPE_TO_GERMAN_NAME.main, value: EIV_ENTRY_TYPE.MAIN },
  { label: EIV_ENTRY_TYPE_TO_GERMAN_NAME.guest, value: EIV_ENTRY_TYPE.GUEST },
];

const DEFAULT_RADIO_OPTIONS = [
  { value: false, label: 'Nein' },
  { value: true, label: 'Ja' },
];

const FIELD_NAME_MAPPING = [
  { key: 'companyName1', label: 'Firmenname 1', aliases: ['firmenname1'] },
  { key: 'companyName2', label: 'Firmenname 2', aliases: ['firmenname2'] },
  { key: 'companyName3', label: 'Firmenname 3', aliases: ['firmenname3'] },
  { key: 'companyOwner', label: 'Ansprechpartner', aliases: ['firmeninhaber', 'ansprechpartner'] },
  { key: 'b_anrede_id', label: 'Anrede', aliases: ['b_anrede_id'] },
  {
    key: 'taetigkeitsschwerpunkt',
    label: 'Tätigkeitsschwerpunkt',
    aliases: ['taetigkeitsschwerpunkt'],
  },
  { key: 'companyStreet', label: 'Straße', aliases: ['buero_strasse', 'bueroStrasse'] },
  { key: 'companyStreetId', label: 'Straße', aliases: ['bueroStrasseId'] },
  {
    key: 'companyHouseNumber',
    label: 'Hausnummer',
    aliases: ['buero_hausnummer', 'bueroHausnummer'],
  },
  { key: 'companyHouseNumberAddition', label: 'Hausnummerzusatz', aliases: [] },
  { key: 'companyPostal', label: 'PLZ', aliases: ['buero_plz', 'bueroPlz'] },
  { key: 'companyPostalCity', label: 'PLZ / Ort', aliases: [] },
  { key: 'companyCity', label: 'Ort', aliases: ['buero_ort', 'bueroOrt'] },
  { key: 'companyRegion', label: 'Ortsteil', aliases: ['buero_ortsteil', 'bueroOrtsteil'] },
  { key: 'companyCountry', label: 'Land', aliases: ['buero_land', 'bueroLand'] },
  {
    key: 'companyRegionId',
    label: 'Ortsteil',
    aliases: ['buero_region', 'bueroRegion'],
  },
  { key: 'avaGuestPostal', label: 'PLZ Auftragsort', aliases: [] },
  {
    key: 'mobile',
    label: 'Mobil',
    aliases: ['telefon_mobil', 'telefonMobil', 'handy', 'mobil', 'Mobil', 'mobilnummer', 'mobile'],
  },
  {
    key: 'phone',
    label: 'Telefon',
    aliases: [
      'telefon_geschaeft',
      'telefonGeschaeft',
      'telefon',
      'Telefon',
      'tel',
      'telefonnummer',
      'phone_number',
    ],
  },
  { key: 'email', label: 'E-Mail-Adresse', aliases: ['email'] },
  {
    key: 'netzportalEmail',
    label: 'E-Mail-Adresse',
    aliases: ['netzportal_email', 'netzportalEmail'],
  },
  {
    key: 'eintragungsartStrom',
    label: 'Eintragungsart Strom',
    aliases: ['eintragungsart_strom'],
    type: 'radio',
    radioOptions: EIV_ENTRY_TYPE_RADIO_OPTIONS,
  },
  {
    key: 'eintragungsartGas',
    label: 'Eintragungsart Gas',
    aliases: ['eintragungsart_gas'],
    type: 'radio',
    radioOptions: EIV_ENTRY_TYPE_RADIO_OPTIONS,
  },
  {
    key: 'bEintragungAlsId',
    label: 'Eintragung als (Strom)',
    aliases: ['b_eintragung_als_id', 'bEintragungAlsId'],
  },
  {
    key: 'bEintragungGasAlsId',
    label: 'Eintragung als (Gas)',
    aliases: ['b_eintragung_gas_als_id', 'bEintragungGasAlsId'],
  },
  { key: 'betriebsartStrom', label: 'Betriebsart Strom', aliases: ['b_betriebsart_strom_id'] },
  {
    key: 'betriebsartGas',
    label: 'Betriebsart Gas',
    aliases: ['b_betriebsart_gas_id', 'bBetriebsartGasId'],
  },
  { key: 'pflegendeBU', label: 'Pflegende BU', aliases: ['pflegende_bu', 'pflegendeBu'] },
  {
    key: 'gridProviderEnergy',
    label: 'Netzbetreiber Strom',
    aliases: ['b_netzbetreiber_strom_id', 'bNetzbetreiberStromId'],
    type: 'comboBox',
  },
  {
    key: 'gridProviderGas',
    label: 'Netzbetreiber Gas',
    aliases: ['b_netzbetreiber_gas_id', 'bNetzbetreiberGasId'],
    type: 'comboBox',
  },
  {
    key: 'bDezentraleEinheitStromId',
    label: 'Dezentrale Einheit Strom',
    aliases: ['b_dezentrale_einheit_strom_id', 'bDezentraleEinheitStromId'],
  },
  {
    key: 'bDezentraleEinheitGasId',
    label: 'Dezentrale Einheit Gas',
    aliases: ['b_dezentrale_einheit_gas_id', 'bDezentraleEinheitGasId'],
  },
  {
    key: 'foreignCompanyIdEnergy',
    label: 'Ausweis-Nummer Strom',
    aliases: ['ausweisnr_fremd_strom', 'ausweisnrFremdStrom'],
  },
  {
    key: 'foreignCompanyIdGas',
    label: 'Ausweis-Nummer Gas',
    aliases: ['ausweisnr_fremd_gas', 'ausweisnrFremdGas'],
  },
  {
    key: 'craftsChamberArea',
    label: 'Ausgestellt von',
    aliases: ['b_hwkbereich_id', 'bHwkbereichId'],
  },
  { key: 'craftsChamberNumber', label: 'Betriebsnummer', aliases: ['hwknummer', 'hwkNummer'] },
  {
    key: 'craftsChamberDate',
    label: 'Ausstellungsdatum',
    aliases: ['hwkdatum', 'hwkDatum'],
    isDate: true,
  },
  {
    key: 'businessRegistrationLocation',
    label: 'Ort (Gewerbeanmeldung)',
    aliases: ['gewerbeanmeldung_ort', 'gewerbeanmeldungOrt'],
  },
  {
    key: 'businessRegistrationDate',
    label: 'Ausstellungsdatum (Gewerbeanmeldung)',
    isDate: true,
    aliases: [
      'gewerbeanmeldung_ausstellungsdatum',
      'gewerbeanmeldungAusstellungsdatum',
      'gewerbeanmeldung_datum',
      'gewerbeanmeldungDatum',
    ],
  },
  {
    key: 'commercialRegisterNumber',
    label: 'HRA/-B-Nummer',
    aliases: ['hrabnummer', 'hrabNummer'],
  },
  { key: 'commercialRegisterLocation', label: 'Amtsgericht', aliases: ['registergericht'] },
  {
    key: 'commercialRegisterDate',
    isDate: true,
    label: 'Auszug vom',
    aliases: ['register_letzte_aenderung', 'registerLetzteAenderung'],
  },
  { key: 'betriebshaftpflicht', label: 'Betriebshaftpflicht', aliases: ['betriebshaftpflicht'] },
  {
    key: 'angestellter',
    label: 'Angestellter',
    aliases: ['angestellter'],
    type: 'radio',
    radioOptions: [
      { value: 1, label: 'Ja' },
      { value: 2, label: 'Nein' },
    ],
  },
  { key: 'firstName', label: 'Vorname', aliases: ['vorname'] },
  { key: 'lastName', label: 'Nachname', aliases: ['nachname', 'name'] },
  { key: 'birthdate', label: 'Geburtsdatum', aliases: ['geburtsdatum'], isDate: true },
  {
    key: 'expertEnergyValidityDate',
    isDate: true,
    label: 'Gültig bis (Strom)',
    aliases: ['gueltig_bis_strom', 'gueltigBisStrom'],
  },
  {
    key: 'expertGasValidityDate',
    isDate: true,
    label: 'Gültig bis (Gas)',
    aliases: ['gueltig_bis_gas', 'gueltigBisGas'],
  },
  {
    key: 'energyValidityDate',
    isDate: true,
    label: 'Strom-Ausweis gültig bis',
    aliases: ['energy_validity_date'],
  },
  {
    key: 'gasValidityDate',
    isDate: true,
    label: 'Gas-Ausweis gültig bis',
    aliases: ['gas_validity_date'],
  },
  {
    key: 'deletionDateEnergy',
    isDate: true,
    label: 'Austritt am (Strom)',
    aliases: ['deletion_date_energy'],
  },
  {
    key: 'deletionDateGas',
    isDate: true,
    label: 'Austritt am (Gas)',
    aliases: ['deletion_date_gas'],
  },
  {
    key: 'lostDate',
    isDate: true,
    label: 'Verloren am',
    aliases: ['lost_date'],
  },
  {
    key: 'installerEnergyValidityDate',
    isDate: true,
    label: 'Strom-Ausweis gültig bis',
    aliases: ['ausw_strom_gueltig', 'auswStromGueltig'],
  },
  {
    key: 'installerGasValidityDate',
    isDate: true,
    label: 'Gas-Ausweis gültig bis',
    aliases: ['ausw_gas_gueltig', 'auswGasGueltig'],
  },
  {
    key: 'limitationEnergy',
    label: 'Eintragungsart Ergänzung Strom',
    aliases: ['eintragungsart_erg_strom', 'eintragungsartErgStrom'],
  },
  {
    key: 'limitationGas',
    label: 'Eintragungsart Ergänzung Gas',
    aliases: ['eintragungsart_erg_gas', 'eintragungsartErgGas'],
  },
  {
    key: 'hwkBetriebsleiter',
    label: 'HWK Betriebsleiter',
    aliases: ['hwk_betriebsleiter', 'hwkBetriebsleiter'],
    type: 'radio',
  },
  {
    key: 'bBerufsbezeichnungId',
    label: 'Berufsbezeichnung',
    aliases: ['b_berufsbezeichnung_id', 'bBerufsbezeichnungId'],
  },
  {
    key: 'bFachrichtungId',
    label: 'Fachrichtung',
    aliases: ['b_fachrichtung_id', 'bFachrichtungId'],
  },
  { key: 'bZusatzId', label: 'Zusatz', aliases: ['b_zusatz_id', 'bZusatzId'] },
  { key: 'bemerkung', label: 'Bemerkung', aliases: ['bemerkung'] },
  { key: 'kommentar', label: 'Kommentar', aliases: ['kommentar'] },
];

const FIELD_NAME_INDEX = new Map(
  FIELD_NAME_MAPPING.flatMap((entry) => [
    [entry.key, entry],
    ...entry.aliases.map((alias) => [alias, entry]),
  ])
);

export const getCanonicalFieldName = (fieldName) => {
  const name = String(fieldName || '');
  if (!name) {
    return name;
  }
  return FIELD_NAME_INDEX.get(name)?.key ?? name;
};

export const getFieldLabel = (fieldName) => {
  const name = String(fieldName || '');
  if (!name) {
    return null;
  }
  return FIELD_NAME_INDEX.get(name)?.label ?? null;
};

/**
 * Returns the camelCase field name for sending to the backend.
 * Prefers the alias without underscores; falls back to the first alias or the original name.
 *
 * @param {string} fieldName - snake_case or camelCase field name from EIV
 * @returns {string}
 */
export const getCamelCaseFieldName = (fieldName) => {
  const name = String(fieldName || '');
  if (!name) return name;
  const entry = FIELD_NAME_INDEX.get(name);
  if (!entry) return name;
  const camelAlias = entry.aliases.find((a) => !a.includes('_'));
  return camelAlias ?? entry.aliases[0] ?? name;
};

export const isDateField = (fieldName) => {
  const name = String(fieldName || '');
  return FIELD_NAME_INDEX.get(name)?.isDate === true;
};

export const getFieldType = (fieldName) => {
  const name = String(fieldName || '');
  return FIELD_NAME_INDEX.get(name)?.type ?? null;
};

export const getRadioOptions = (fieldName) => {
  const name = String(fieldName || '');
  return FIELD_NAME_INDEX.get(name)?.radioOptions ?? DEFAULT_RADIO_OPTIONS;
};
